import { module } from 'angular';

import { HELP_FIELD_COMPONENT } from './helpField.component';
import { HELP_CONTENTS } from './help.contents';

export const HELP_MODULE = 'spinnaker.core.help';
module(HELP_MODULE, [
  HELP_CONTENTS,
  HELP_FIELD_COMPONENT
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/help/help.module.ts